import { MouseEvent, useMemo } from 'react';

import { useTranslation } from 'libs/i18n';
import { Link, ROUTES, useNavigate } from 'libs/navigation';
import { Button, Stack, Typography } from 'libs/ui';
import { ColorsLight } from 'libs/ui/theme';

import {
  LoginFormType,
  Field,
  Form,
  Submit,
  FormErrors,
  getSchema,
} from '../../forms/loginFormForm';

export interface LoginFormProps {
  onSubmit: (values: LoginFormType) => void;
  loading?: boolean;
  formError?: FormErrors;
}

export const LoginForm = ({ loading, formError, onSubmit }: LoginFormProps) => {
  const { t } = useTranslation();
  const scheme = useMemo(() => getSchema(t), [t]);

  const { navigate } = useNavigate();

  const onClickRegistration = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    navigate(ROUTES.registration.fullPath, {}, { event });
  };

  return (
    <Form
      initialErrors={{ ...formError }}
      initialValues={{ rememberMe: true }}
      validationSchema={scheme}
      onSubmit={onSubmit}
    >
      <Stack spacing={48} spacingMobile={8}>
        <Stack spacing={12}>
          <Stack spacing={24}>
            <Field.Text
              allowSubmit
              helperTextAbsolute
              label={t('auth.login.email.label')}
              name="email"
              placeholder={t('auth.login.email.placeholder')}
              type="email"
            />
            <Field.Password
              allowSubmit
              helperTextAbsolute
              label={t('auth.login.password.label')}
              name="password"
              placeholder={t('auth.login.password.placeholder')}
            />
          </Stack>

          <Stack direction="row" justifyContent="flex-end">
            <Link params={{}} to={ROUTES.restorePassword.fullPath}>
              <Typography color={ColorsLight.gray250} variant="captionMedium">
                {t('auth.login.forgotPassword')}
              </Typography>
            </Link>
          </Stack>
        </Stack>
        <Stack spacing={20} spacingMobile={16}>
          <Submit label={t('auth.login.submitButton')} loading={loading} />
          <Button
            fullWidth
            href={ROUTES.registration.fullPath}
            label={t('auth.login.regButton')}
            mode="outlined"
            onClick={onClickRegistration}
          />
        </Stack>
      </Stack>
    </Form>
  );
};
